import { InferType, number, object, string } from 'yup';

export const stripeBodySchema = object({
  priceId: string().required(),
  customer_email: string().email().required(),
  customer_uuid: string().required(),
});

export type StripeBodySchema = InferType<typeof stripeBodySchema>;

export const stripeCreateSessionResponseSchema = object({
  stripeUrl: string().url().required(),
});

export type StripeCreateSessionResponse = InferType<typeof stripeCreateSessionResponseSchema>;

export const stripeSessionIdBodySchema = object({
  sessionId: string().required(),
});

export type StripeCheckoutSessionStatus = 'complete' | 'expired' | 'open';

export type StripeSessionIdBodySchema = InferType<typeof stripeSessionIdBodySchema>;

export const stripeCheckoutSessionSchema = object({
  amount_total: number().required(),
  id: string().required(),
  status: string().oneOf(['complete', 'expired', 'open']).required().nullable(),
});

export type StripeCheckoutSession = InferType<typeof stripeCheckoutSessionSchema>;
